//
// popover.js
// Theme module
//
import { Tooltip } from 'bootstrap';
function loadTooltips() {
    const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltips.forEach((tooltip)=>{
        new Tooltip(tooltip);
    });
}
window.addEventListener('ready', loadTooltips);
window.addEventListener('turbolinks:load', loadTooltips);
